import { addClientSideAsset, deleteClientSideAssets } from '../privateActions';
import { mutatorAction, orchestrator } from 'satcheljs';
import { onTimeStreamAssetCreated, onTimeStreamAssetsDeleted } from '../actions';
import type {
    ProjectId,
    AssetId,
    NewOutlookSpaceAsset,
    TimeStreamProject,
} from 'owa-timestream-types';
import getAssetOrUndefined from '../selectors/getAssetOrUndefined';
import getStore from '../store';

orchestrator(addClientSideAsset, ({ projectId, clientAssetId, asset, actionSource }) => {
    const project = getStore().projects.get(projectId);
    if (project) {
        setClientAsset(project, clientAssetId, asset);
        onTimeStreamAssetCreated(projectId, clientAssetId, actionSource);
    }
});

orchestrator(deleteClientSideAssets, ({ projectId, assetIds }) => {
    const project = getStore().projects.get(projectId);
    if (project) {
        deleteClientAssets(project, projectId, assetIds);
        onTimeStreamAssetsDeleted(assetIds);
    }
});

const setClientAsset = mutatorAction(
    'setClientAsset',
    (project: TimeStreamProject, clientAssetId: AssetId, asset: NewOutlookSpaceAsset) => {
        const { assets, renderingOrder } = project;
        const { type, x, y, width, height, payload, isCaptured } = asset;
        const createdDateTime = new Date().toISOString();
        assets.set(clientAssetId, {
            outlookSpaceAssetId: null,
            outlookSpaceAssetKey: null,
            type,
            bounds: {
                x,
                y,
                width: width || 0,
                height: height || 0,
                lastKnownWidth: 0,
                lastKnownHeight: 0,
            },
            payload,
            payloadId: 0,
            createdDateTime,
            lastModifiedDateTime: createdDateTime,
            isCaptured: !!isCaptured,
            isNewlyCreated: true,
            children: [],
            dueDate: undefined,
            isComplete: false,
            color: undefined,
            taskId: undefined,
            parentId: undefined,
            order: undefined,
            deleted: false,
        });
        renderingOrder.push(clientAssetId as AssetId);
    }
);

const deleteClientAssets = mutatorAction(
    'deleteClientAssets',
    (project: TimeStreamProject, projectId: ProjectId, assetIds: AssetId[]) => {
        const { renderingOrder } = project;
        assetIds.forEach(assetId => {
            // remove the asset from the parent children array
            const asset = getAssetOrUndefined(projectId, assetId);
            if (asset?.parentId) {
                const parentAsset = getAssetOrUndefined(projectId, asset.parentId);
                const bucketAssetsChildIndex = parentAsset?.children?.indexOf(assetId);
                if (bucketAssetsChildIndex !== undefined && bucketAssetsChildIndex >= 0) {
                    parentAsset?.children?.splice(bucketAssetsChildIndex, 1);
                }
            }

            renderingOrder.remove(assetId);
            if (!!asset) {
                asset.deleted = true;
            }
        });
    }
);
